import {
  Box,
  Button,
  Container,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Select,
  Text,
  Textarea,
  useToast,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { useNavigate, useParams } from "react-router-dom";
import {
  ICourseSession,
  ICourseTerm,
} from "../../../models/admin/courseTermSession.model";
import AdminHelpers from "../../../services/admin/admin.service";
import trainercoursesService from "../../../services/trainer/trainercourses.service";

export default function NewAnnouncement() {
  const navigate = useNavigate();
  const toast = useToast();
  const [students, setStudents] = useState<any[]>();
  const [session, setSession] = useState<ICourseSession[]>([]);
  const [term, setTerms] = useState<ICourseTerm[]>([]);
  const params = useParams();
  const course_id = params.course_id;

  useEffect(() => {
    AdminHelpers.getSessions()
      .then((response) => {
        setSession(response.data);
      })
      .catch((err) => err);

    AdminHelpers.getTerms()
      .then((response) => {
        setTerms(response.data);
      })
      .catch((err) => err);

    const maingender = [
      {
        id: "1",
        title: "Bolaji Muili",
      },
      {
        id: "2",
        title: "Olushola",
      },
    ];
    setStudents(maingender);
  }, []);

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.title) {
        errors.title = "Topic is required";
      }
      if (!values.description) {
        errors.description = "description is required";
      }

      return errors;
    },
    initialValues: {
      model_id: course_id,
      announcement_for: "Courses",
      session_id: "",
      term_id: "",
      title: "",
      description: "",
    },
    onSubmit: async (values) => {
      const announcementInfo: any = {
        model_id: course_id, // uuid of course
        announcement_for: "Courses",
        session_id: values.session_id,
        term_id: values.term_id,
        title: values.title,
        description: values.description,
      };
      try {
        const announcementInfoRes =
          await trainercoursesService.createAnnouncement(announcementInfo);
        if (announcementInfoRes.status === "success") {
          toast({
            title: "Announcement",
            description: "Announcement posted",
            status: "success",
          });
          formik.resetForm();
          navigate(-1);
        }
      } catch (error) {
        toast({
          title: "Announcement",
          description: "Something went Wrong. Try again later",
          status: "error",
        });
      }
    },
  });
  return (
    <Box minHeight="100vh" pb="30px" bg="#F9F8F8" width={"100%"}>
      <Container
        width={{ lg: "50%", md: "80%", sm: "95%", base: "95%" }}
        maxWidth={"84%"}
        px={0}
        pt="100px"
        right={0}
        bg="F9F8F8"
        mx="auto"
      >
        <Box
          mb="60px"
          display="flex"
          alignItems="center"
          border="1px solid #616161"
          px="5px"
          py="7px"
          width="200px"
          borderRadius="5px"
          cursor="pointer"
        >
          <HiArrowNarrowLeft color="#616161" fontSize="20px" />
          <Text
            fontSize="14px"
            color="#616161"
            pl="5px"
            onClick={() =>
              navigate(`/trainer/course/${course_id}/announcement`)
            }
            fontWeight={700}
          >
            Back to Announcements
          </Text>
        </Box>
        <Box
          bg="white"
          px="40px"
          py="30px"
          boxShadow="sm"
          rounded="lg"
          height="auto"
          mb="30px"
        >
          <Text fontWeight="700" fontSize="24px" color="#1E1E1E">
            New Announcement
          </Text>
          <Box mt={4}>
            <form onSubmit={formik.handleSubmit}>
              <FormControl
                mt={6}
                mb="10px"
                isInvalid={
                  formik.errors.title && formik.touched.title ? true : false
                }
              >
                <FormLabel
                  fontWeight="700"
                  color="brand.3"
                  mb="10px"
                  fontSize="14px"
                >
                  Title{" "}
                  <Text as="span" color="red">
                    (*){" "}
                  </Text>
                </FormLabel>
                <Input
                  type="text"
                  id="title"
                  name="title"
                  placeholder="Enter title"
                  onChange={formik.handleChange}
                  fontSize={13}
                  value={formik.values.title}
                  height={"2.5rem"}
                />
                <FormErrorMessage fontSize={12}>
                  {formik.errors.title}
                </FormErrorMessage>
              </FormControl>
              {/* <FormControl mt={6} isInvalid={(formik.errors.recipient && formik.touched.recipient) ? true : false}>
                                <FormLabel fontWeight="normal" color="brand.3" mb='10px' fontSize={13}>Recipient</FormLabel>
                                <Select variant="outline" bg="inputText.500" size="sm" fontSize={12} placeholder="All Student" value={formik.values.recipient} name="courseFormat" onChange={formik.handleChange} color="brand.subtitle" >
                                    {
                                        students?.map(each => <option key={each.id} value={each.format_id}> {each.title} </option>)
                                    }
                                </Select>
                                <FormErrorMessage fontSize={12} >{formik.errors.recipient}</FormErrorMessage>
                            </FormControl> */}
              <FormControl
                mb="10px"
                isInvalid={
                  formik.errors.session_id && formik.touched.session_id
                    ? true
                    : false
                }
              >
                <FormLabel fontWeight="700" color="brand.3" fontSize="14px">
                  Session{" "}
                  <Text as="span" color="red">
                    (*){" "}
                  </Text>
                </FormLabel>
                <Select
                  variant="outline"
                  bg="inputText.500"
                  size="md"
                  placeholder="Select session"
                  value={formik.values.session_id}
                  name="session_id"
                  onChange={formik.handleChange}
                  fontSize="14px"
                  color="brand.subtitle"
                >
                  {session.map((each, index) => (
                    <option key={index} value={each.id}>
                      {" "}
                      {each.title}{" "}
                    </option>
                  ))}
                </Select>
                <FormErrorMessage fontSize={12}>
                  {formik.errors.session_id}
                </FormErrorMessage>
              </FormControl>
              <FormControl
                mb="10px"
                isInvalid={
                  formik.errors.term_id && formik.touched.term_id ? true : false
                }
              >
                <FormLabel fontWeight="700" color="brand.3" fontSize="14px">
                  Term{" "}
                  <Text as="span" color="red">
                    (*){" "}
                  </Text>
                </FormLabel>
                <Select
                  variant="outline"
                  bg="inputText.500"
                  size="md"
                  placeholder="Select term"
                  value={formik.values.term_id}
                  name="term_id"
                  onChange={formik.handleChange}
                  fontSize="14px"
                  color="brand.subtitle"
                >
                  {term.map((each, index) => (
                    <option key={index} value={each.id}>
                      {" "}
                      {each.title}{" "}
                    </option>
                  ))}
                </Select>
                <FormErrorMessage fontSize={12}>
                  {formik.errors.term_id}
                </FormErrorMessage>
              </FormControl>
              <FormControl
                mt={6}
                id="description"
                isInvalid={
                  formik.errors.description && formik.touched.description
                    ? true
                    : false
                }
              >
                <FormLabel
                  fontWeight="700"
                  color="brand.3"
                  mb="10px"
                  fontSize="14px"
                >
                  Write here..
                </FormLabel>
                <Textarea
                  p={4}
                  bg="inputText.500"
                  fontSize={12}
                  size="sm"
                  height="150px"
                  placeholder="description of the announcement"
                  name="description"
                  onChange={formik.handleChange}
                  value={formik.values.description}
                />
                <FormErrorMessage fontSize={12}>
                  {formik.errors.description}
                </FormErrorMessage>
              </FormControl>
              {/* <HStack spacing='15px' mt={6}>
                                <Checkbox pb='28px' colorScheme='red' defaultChecked>
                                </Checkbox>
                                <Box>
                                    <Text color='#353535' fontWeight='600' fontSize='16px' pb='4px'>Send a copy to student mail</Text>
                                    <Text color='#9E9E9E' fontSize='12px' width='350px'>A copy of this announcement will be sent to the email of all students participating in this course</Text>
                                </Box>
                            </HStack> */}
              {/* <HStack spacing='15px' mt={6}>
                                <Checkbox pb='28px' colorScheme='red'>
                                </Checkbox>
                                <Box>
                                    <Text color='#353535' fontWeight='600' fontSize='16px' pb='4px'>Schedule announcement</Text>
                                    <Text color='#9E9E9E' fontSize='12px' width='350px'>Schedule a future date you want this announcement sent to your students</Text>
                                </Box>
                            </HStack> */}
              <Box width="70%">
                {/* <HStack mt='15px'>
                                <FormControl >
                                    <FormLabel fontWeight="600" color="#616161" fontSize={13}>Send on</FormLabel>
                                    <InputGroup>
                                        <Input placeholder="Select Start Date" type="date" bg="inputText.500" name="startDate" value={formik.values.startDate} onChange={formik.handleChange} fontSize={12} />
                                        <InputRightElement pointerEvents="none" children={<VscCalendar fontSize={20} color="#7883A7" />} />
                                    </InputGroup>
                                </FormControl>
                                <FormControl >
                                  
                                    <InputGroup pt='27px'>
                                        <Input placeholder="Select time" type="time" bg="inputText.500" name="startDate" value={formik.values.startTime} onChange={formik.handleChange} fontSize={12} />
                                        <InputRightElement pointerEvents="none" children={<VscCalendar fontSize={20} color="#7883A7" />} />
                                    </InputGroup>
                                </FormControl>
                            </HStack> */}
              </Box>
              <Flex mt={12} justifyContent="flex-end">
                <Button
                  borderRadius={0}
                  colorScheme="red"
                  type="submit"
                  isLoading={formik.isSubmitting}
                  onClick={() => {
                    formik.handleSubmit();
                  }}
                  size="sm"
                  px={6}
                  fontSize={14}
                >
                  {" "}
                  POST ANNOUNCEMENT
                </Button>
              </Flex>
            </form>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
